import { create } from 'zustand';

export const useNotifStore = create((set, get) => ({
  notifications: [],
  unread: 0,
  setNotifications: (notifications) => set({
    notifications,
    unread: notifications.filter(n => !n.read).length,
  }),
  markRead: (id) => set(s => ({
    notifications: s.notifications.map(n => n.id === id ? { ...n, read: true } : n),
    unread: Math.max(0, s.unread - 1),
  })),
}));
